import React from "react";
import { Phone } from "lucide-react";

const PHONE_DISPLAY = "(689) 228-9122";
const PHONE_HREF = "tel:+16892289122";

export const PhoneButton = ({
  size = "lg",
  className = "",
  label = `Call ${PHONE_DISPLAY}`,
  testId = "call-cta",
  showSubtext = false,
  fullWidth = false,
}) => {
  const sizeClasses = {
    sm: "min-h-[56px] px-6 text-lg",
    md: "min-h-[64px] px-7 text-xl",
    lg: "min-h-[72px] px-8 text-2xl md:text-3xl",
    xl: "min-h-[80px] px-10 text-2xl md:text-4xl",
  };
  return (
    <a
      href={PHONE_HREF}
      data-testid={testId}
      aria-label={`Call us at ${PHONE_DISPLAY}`}
      className={[
        "group inline-flex items-center justify-center gap-3 rounded-full",
        "bg-green-700 text-white font-bold tracking-tight",
        "shadow-lg shadow-green-900/20 hover:bg-green-800",
        "focus:outline-none focus-visible:ring-4 focus-visible:ring-green-300",
        "transition-colors duration-200 pulse-ring",
        fullWidth ? "w-full" : "",
        sizeClasses[size],
        className,
      ].join(" ")}
    >
      <Phone
        className="h-7 w-7 md:h-8 md:w-8 fill-white stroke-white"
        aria-hidden="true"
      />
      <span className="flex flex-col items-start leading-tight whitespace-nowrap">
        <span>{label}</span>
        {showSubtext && (
          <span className="text-xs md:text-sm font-medium opacity-90">
            Free quote • No obligation
          </span>
        )}
      </span>
    </a>
  );
};

export const PHONE = { display: PHONE_DISPLAY, href: PHONE_HREF };
